export default "__VITE_ASSET__E1JX8GBH__"